
import React from 'react';
import { Link } from 'react-router-dom';
import { Trash2 } from 'lucide-react';

const Footer = () => {
  return (
    <>
      {/* Soft divider line */}
      <div className="w-full h-px bg-gray-200" />
      
      <footer className="bg-navy text-white py-6 px-8 font-sans">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            {/* Copyright - left aligned on desktop, centered on mobile */}
            <div className="text-center md:text-left">
              <p className="text-sm">
                © 2025 Migrante Amigo. Todos los derechos reservados.
              </p>
            </div>
            
            {/* Links - right aligned on desktop, centered on mobile */}
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
              <Link 
                to="/privacy-policy" 
                className="text-sm hover:underline transition-all duration-200 min-h-[44px] flex items-center"
              >
                Política de Privacidad
              </Link>
              <Link 
                to="/delete-account" 
                className="text-sm hover:underline transition-all duration-200 min-h-[44px] flex items-center gap-2"
              >
                <Trash2 className="w-4 h-4" />
                Eliminar Cuenta
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
